import { atom } from "jotai";
import { ScreenType, UserInterface } from "../types";

export const firebaseInitAtom = atom<boolean>(false);

export const userAtom = atom<UserInterface | undefined>(undefined);

export const screenAtom = atom<ScreenType>("Home");
